var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',{staticClass:"paragraph"},[_vm._v(" © Gestor de processos "+_vm._s(_vm.varsion)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }